import {Injectable} from '@angular/core';
import {DocFile, FilePermission, FilePermissionSetting, FilePermissionType} from '@app/shared/classes/doc-file';
import {DocumentType, Roles, UserInfo} from "@app/shared";
import {UserService} from "@app/core";

@Injectable()
export class FileExplorerService {

  constructor(private user: UserService) {
  }


  /**
   * @desc every doc file has associated docType
   * @param docFiles
   */
  allFilesHaveDocType(docFiles: DocFile[]): boolean {
    return (docFiles.findIndex(file => !file.docTypeId) < 0);
  }

  /**
   * Returns list of doc files with matching Document type
   * @param docFiles
   * @param docType
   */
  filterFilesBasedOnDocType(docFiles: DocFile[], docType: DocumentType): DocFile[] {
    return docFiles.filter(file => file.docTypeName === docType);
  }

  /**
   * @desc Process permision settings on the fle and set
   * @param docFiles - DocFiles to populate the file permission list
   * @param isApprover - Is the context user approver
   * @returns this.docFiles - Updated docFiles with permission object populated
   */
  processPermissionsForFiles(docFiles: DocFile[], isApprover: boolean): DocFile[] {

    docFiles.forEach(file => {
      this.processIndividualFilePermissions(file, isApprover);
    });

    return docFiles.filter(file => file.permission && (file.permission.canRead || file.permission.canWrite || file.permission.canDelete || file.permission.canPermit));
  }

  processIndividualFilePermissions(docFile: DocFile, isApprover: boolean) {
    let permissionSettings: FilePermissionSetting[] = docFile.displayPermissionSettings;
    let permissionToSet: FilePermission = new FilePermission();
    let isUserOwner: boolean = this.isUserOwner(docFile, this.user.info);
    permissionSettings.forEach(permission => {
      let filePermission: FilePermission = permission.permission;
      if (filePermission.filePermissionType == FilePermissionType.Owner && isUserOwner) {
        this.populateAccessPermission(permissionToSet, filePermission);
      } else if (filePermission.filePermissionType == FilePermissionType.Approver && isApprover) {
        this.populateAccessPermission(permissionToSet, filePermission);
      } else if (filePermission.filePermissionType == FilePermissionType.Role && this.user.isAuthorized([filePermission.roleValue as Roles])) {
        this.populateAccessPermission(permissionToSet, filePermission);
      }
    });
    //If user is CSR/ORG admin set all permissions
    if (this.user.isAuthorized([Roles.CSRAdmin, Roles.OrgAdmin])) {
      permissionToSet.canDelete = true;
      permissionToSet.canRead = true;
      permissionToSet.canWrite = true;
      permissionToSet.canPermit = true;
    }
    docFile.permission = permissionToSet;
  }

  isUserOwner(docFile: DocFile, userInfo: UserInfo) {
    return (docFile.ownerId == userInfo.userId || docFile.ownerId == userInfo.id);
  }


  populateAccessPermission(permissionToSet: FilePermission, rxPermission: FilePermission) {

    if (rxPermission.canDelete) {
      permissionToSet.canDelete = true;
    }
    if (rxPermission.canWrite) {
      permissionToSet.canWrite = true;
    }
    if (rxPermission.canRead) {
      permissionToSet.canRead = true;
    }
    if (rxPermission.canPermit) {
      permissionToSet.canPermit = true;
    }
  }
}
